// Importing necessary modules
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { thunk } from 'redux-thunk'; // Corrected thunk import
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // Default localStorage for web
import { FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist'; // Actions related to persistence

// Importing individual reducers
import AdminReducer from '../reducers/Admin'

import SelectedSlice from '../slice/SelectedSlice';

// Combining reducers
const rootReducer = combineReducers({
  admin: AdminReducer,
  selected: SelectedSlice,
  
});

// Persist configuration
const persistConfig = {
  key: 'root', // This key should be the same for both the persisted store and your root reducer
  storage, // Using localStorage for persistence
  whitelist: ['admin', 'selected'], // List of reducers to persist
};

// Applying persistReducer to rootReducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Creating the Redux store using configureStore (RTK)
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignoring these actions to avoid issues with persisting
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(thunk), // Adding thunk for async actions
});

// Creating persisted store for persistence management
export const persistedStore = persistStore(store);

// Function to clear Redux state (code-wise, not from storage)
export const clearState = () => {
  persistedStore.purge(); // This clears only Redux state, keeping localStorage data intact
};
